/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_TitleInputs */

const en_directory_promotion_benefits_title = /** @type {(inputs: Directory_Promotion_Benefits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What Sponsor includes`)
};

const zh_directory_promotion_benefits_title = /** @type {(inputs: Directory_Promotion_Benefits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor 套餐包含`)
};

/**
* | output |
* | --- |
* | "What Sponsor includes" |
*
* @param {Directory_Promotion_Benefits_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_title = /** @type {((inputs?: Directory_Promotion_Benefits_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_title(inputs)
	return zh_directory_promotion_benefits_title(inputs)
});
export { directory_promotion_benefits_title as "directory.promotion.benefits_title" }